export default __webpack_public_path__ + "static/media/‘‘.afc6082f.svg";